interface SkeletonProps {
  className?: string;
  width?: string | number;
  height?: string | number;
}

export function Skeleton({ className = '', width, height }: SkeletonProps) {
  return (
    <>
      <style>{`
        @keyframes shimmer {
          0% {
            background-position: -200% 0;
          }
          100% {
            background-position: 200% 0;
          }
        }
      `}</style>
      <div
        className={`rounded-md ${className}`}
        style={{
          width,
          height,
          background:
            'linear-gradient(90deg, rgb(229 224 219 / 0.6) 25%, rgb(243 240 236 / 0.4) 50%, rgb(229 224 219 / 0.6) 75%)',
          backgroundSize: '200% 100%',
          animation: 'shimmer 1.5s ease-in-out infinite',
        }}
      />
    </>
  );
}
